import { gqlClient } from '@/api/graphql-client';
import applianceKeys from '@/api/queries/appliances/keyFactory';
import productSpecKeys from '@/api/queries/productSpecs/keyFactory';
import { graphql } from '@/gql';
import { ArchiveApplianceMutation as ArchiveApplianceMutationResult } from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const ArchiveApplianceMutation = graphql(`
  mutation ArchiveAppliance($id: ID!) {
    archiveAppliance(id: $id)
  }
`);

const useArchiveAppliance = (
  options?: UseMutationOptions<ArchiveApplianceMutationResult, Error, string>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => gqlClient.request(ArchiveApplianceMutation, { id }),
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: applianceKeys.all });
      // The spec search exposes each spec's Appliance, so refresh it too.
      void queryClient.invalidateQueries({ queryKey: productSpecKeys.all });
    },
    ...options,
  });
};

export default useArchiveAppliance;
